import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '../api-configuration';
import { NotificationsResponseDto } from 'src/app/shared/model/notifications';
import { ApiResponse } from '../api-response.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  constructor(private http: HttpClient, private config: ApiConfiguration) {}

  getUnreadNotificationsByUser(): Observable<
    ApiResponse<NotificationsResponseDto>
  > {
    const url = `${this.config.rootUrl}/notificacion-lectura/obtener-no-leidos-por-usuario`;
    return this.http.get<ApiResponse<NotificationsResponseDto>>(url);
  }

  markAllAsRead(): Observable<ApiResponse<any>> {
    const url = `${this.config.rootUrl}/notificacion-lectura/todos-leidos`;
    return this.http.post<ApiResponse<any>>(url, {});
  }
}
